import GetRequestFormsRequestModelBase from '../_generated/modelBases/get-request-forms-request-model-base';

export default class GetRequestFormsRequestModel extends GetRequestFormsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
